import React from 'react';
import { BadgeCheck } from 'lucide-react';

export default function AuthenticatedBadge({ size = 'sm', className = '' }) {
  const dims = size === 'lg' ? 'text-xs px-3 py-1.5' : 'text-[10px] px-2 py-1';
  return (
    <span className={`inline-flex items-center gap-1.5 border border-accent text-accent ${dims} uppercase tracking-[0.18em] font-medium ${className}`} data-testid="authenticated-badge">
      <BadgeCheck size={size === 'lg' ? 14 : 11} strokeWidth={1.4} />
      Authenticated
    </span>
  );
}
